export { default as Arrow } from './Arrow.svg';
export { default as ShortArrow } from './ShortArrow.svg';
export { default as Exit } from './Exit.svg';
export { default as WhiteExit } from './WhiteExit.svg';
export { default as Warning } from './Warning.svg';
export { default as Vi } from './Vi.svg';
export { default as Headphones } from './Headphones.svg';
export { default as AccordionArrowIcon } from './AccordionArrow.svg';
export { default as SupportIcon } from './Support.svg';
export { default as LeftArrow } from './LeftArrow.svg';
export { default as Search } from './Search.svg';
export { default as Excel } from './Excel.svg';
export { default as Hamburger } from './Hamburger.svg';
export { default as Logo } from './Logo.svg';
export { default as LogoMOD } from './LogoMOD.png';
export { default as Ellipse } from './Ellipse.svg';
export { default as PersonalZone } from './PersonalZone.svg';
export { default as Person } from './Person.svg';
export { default as DateIcon } from './Date.svg';
export { default as ReportErrorError } from './Suppliers/ReportErrorError.svg';
export { default as ReportErrorFileInfo } from './Suppliers/ReportErrorFileInfo.svg';
export { default as ClickAbleArrow } from './ClickAbleArrow.svg';
export { default as DocumentsIcon } from './Documents.svg';
export { default as Doctor } from './Doctor.svg';
export { default as Stamp } from './Stamp.svg';
export { default as Hammer } from './Hammer.svg';
export { default as File } from './File.svg';
export { default as Download } from './Download.svg';
export { default as DownloadIcon } from './DownloadIcon.svg';
export { default as GreenVi } from './GreenVi.svg';
export { default as UserIcon } from './User.svg';
export { default as UserDarkIcon } from './UserDark.svg';
export { default as MedsHistory } from './MedsHistory.svg';
export { default as NewMed } from './NewMed.svg';
export { default as PermanentMeds } from './PermanentMeds.svg';
export { default as LeftArrowLarge } from './LeftArrowLarge.svg';
export { default as LeftArrowPinkPurple } from './LeftArrowPinkPurple.svg';
export { default as Blue_arrow_shadow } from './Blue_arrow_shadow.svg';
export { default as Blue_shadow } from './blue-fix4.png';
export { default as Blue_bold } from './Blue_bold.png';
export { default as Important } from './Important.svg';
export { default as Icon1 } from './Icon1.svg';
export { default as Icon2 } from './Icon2.svg';
export { default as Icon3 } from './Icon3.svg';
export { default as GreenV } from './GreenV.svg';
export { default as Denied } from './Denied.svg';
export { default as ReqStopped } from './ReqStopped.svg';
export { default as ActionBtnBackground } from './ActionBtnBackground.svg';
export { default as AccordionArrowWhite } from './AccordionArrowWhite.svg';
export { default as Attention } from './Attention.svg';
export { default as WarningBlue } from './WarningBlue.svg';
export { default as PdfDocument } from './PdfDocument.svg';
export { default as BlueX } from './BlueX.svg';
export { default as Stop } from './Stop.svg';
export { default as BgCircleBlue } from './BgCircleBlue.svg';
export { default as BgCircleOrange } from './BgCircleOrange.svg';
export { default as BgCircleBlueMobile } from './BgCircleBlueMobile.svg';
export { default as BgCircleOrangeMobileMiddle } from './BgCircleOrangeMobileMiddle.svg';
export { default as BgCircleOrangeMobileBottom } from './BgCircleOrangeMobileBottom.svg';
export { default as BgDesk } from './BgDesk.png';
export { default as BgMobile } from './BgMobile.png';
export { default as Iphone } from './Iphone.svg';
export { default as CHB_Checked } from './CHB_Checked.svg';
export { default as CHB_Unchecked } from './CHB_Unchecked.svg';
export { default as StepperIcon } from './StepperIcon.svg';
export { default as StepperIconActive } from './StepperIconActive.svg';
export { default as StepperIconCompleted } from './StepperIconCompleted.svg';
export { default as StepperIconCompleted_NEW } from './StepperIconCompleted_new.svg';
export { default as SupportMobile } from './SupportMobile.svg';
export { default as ContactUsMobileBackground } from './ContactUsMobileBackground.svg';
export { default as HeaderDisconnect } from './HeaderDisconnect.svg';
export { default as HeaderUpdatePersonalDetails } from './HeaderUpdatePersonalDetails.svg';
export { default as RightArrow } from './RightArrow.svg';
export { default as HeadphonesGrayBackground } from './HeadphonesGrayBackground.svg';
export { default as AccordionArrowBlue } from './AccordionArrowBlue.svg';
export { default as Eraser } from './Eraser.svg';
export { default as DesktopScreen } from './DesktopScreen.svg';
export { default as FilterIcon } from './FilterIcon.svg';
export { default as LeftArrowDatePicker } from './LeftArrowDatePicker.svg';
export { default as RightArrowDatePicker } from './RightArrowDatePicker.svg';
export { default as OrderEquipment } from './OrderEquipment.svg';
export { default as EligibilityRequest } from './EligibilityRequest.svg';
export { default as RequesRefund } from './RequesRefund.svg';
export { default as NotificationBlueCircle } from './NotificationBlueCircle.svg';
export { default as ArrowBackBlue } from './ArrowBackBlue.svg';
export { default as ArrowNextBlue } from './ArrowNextBlue.svg';
export { default as NoDataIcon } from './NoDataIcon.svg';
export { default as OrderMedsBtnBlueBg } from './OrderMedsBtnBlueBg.svg';
export { default as RequestNewMedBtnCircleBg } from './RequestNewMedBtnCircleBg.svg';
export { default as PaperApprovedMobile } from './PaperApprovedMobile.svg';
export { default as PaperApprovedDesktop } from './PaperApprovedDesktop.svg';
export { default as BlueInfo } from './BlueInfo.svg';
export { default as TriangleWarning } from './TriangleWarning.svg';
export { default as RedAlert } from './RedAlert.svg';
export { default as GreenSuccess } from './GreenSuccess.svg';
export { default as LeftArrowSmall } from './LeftArrowSmall.svg';
export { default as ListItemBullet } from './ListItemBullet.svg';
export { default as PaperApproved } from './PaperApproved.svg';
export { default as LogoMobile } from './LogoMobile.svg';
export { default as PlusBtn } from './PlusBtn.svg';
export { default as MinusBtn } from './MinusBtn.svg';
export { default as ClearBtn } from './Clear.svg';
export { default as Approved } from './Approved.svg';
export { default as LastStep } from './LastStep.svg';
export { default as DeniedStep } from './DeniedStep.svg';
export { default as SubmitNewFile } from './submitNewFile.svg';
export { default as ArrowUp } from './arrowUp.svg';
export { default as TrashCan } from './TrashCan.svg';
export { default as WatchFile } from './WatchFile.svg';
export { default as UploadFilePurple } from './General/UploadFilePurple.svg';
export { default as NoDocumentsFound } from './NoDocumentsFound.svg';
export { default as DownArrow } from './DownArrow.svg';
export { default as Boy } from './Boy.svg';
export { default as Girl } from './Girl.svg';
export { default as Edit } from './Edit.svg';
export { default as Delete } from './Delete.svg';
export { default as TriangleWarningFill } from './TriangleWarningFill.svg';
export { default as RedAlertFill } from './RedAlertFill.svg';
export { default as GreenSuccessFill } from './GreenSuccessFill.svg';
export { default as ClockIcon } from './Clock.svg';
export { default as BlueChecked } from './BlueChecked.svg';
export { default as PaycheckIcon } from './PaycheckIcon.svg';
export { default as FormIcon } from './FormIcon.svg';
export { default as HandHoldingHeartIcon } from './HandHoldingHeartIcon.svg';
export { default as HeartBetweenHandsIcon } from './HeartBetweenHands.svg';
export { default as PersonHelpingWalkIcon } from './PersonHelpingWalk.svg';
export { default as BagMagnifyGlassIcon } from './BagMagnifyGlass.svg';
export { default as CalendarIcon } from './Calendar.svg';
export { default as BlueCircleBG } from './BlueCircleBG.svg';
export { default as AdvancedSearchIcon } from './AdvancedSearchIcon.svg';
export { default as WarningOutlineIcon } from './WarningOutline.svg';
export { default as Israel } from './Israel.svg';
export { default as Idf } from './Idf.svg';
export { default as Shikum } from './Shikum.svg';
export { default as BgDisabledVeteran } from './BgDisabledVeteran.svg';
export { default as ClockNoBGIcon } from './ClockNoBG.svg';
export { default as DisabledVeteran } from './DisabledVeteran.svg';
export { default as BlueWarningIcon } from './BlueWarning.svg';
export { default as WarningBlueFill } from './WarningBlueFill.svg';
export { default as SearchWithSpot } from './SearchWithSpot.svg';
export { default as NoResults } from './NoResults.svg';
export { default as Supplier1 } from './Supplier1.svg';
export { default as Supplier2 } from './Supplier2.svg';
export { default as OrangeWarningBubble } from './OrangeWarningBubble.svg';
export { default as WarningRed } from './WarningRed.svg';
export { default as AddRequest } from './AddRequest.svg';
export { default as GrayPerson } from './GrayPerson.svg';
export { default as LogoSmall } from './LogoSmall.svg';
export { default as ArrowDown } from './ArrowDown.svg';
export { default as BlueDot } from './BlueDot.svg';
export { default as Stroke } from './Stroke.svg';
export { default as ArrowDown2 } from './ArrowDown2.svg';
export { default as ShikumLogo } from './ShikumLogo.svg';
export { default as MODLogo } from './MODLogo.svg';
export { default as PurpleX } from './General/PurpleX.svg';
export { default as PurpleXLite } from './PurpleXLite.svg';
export { default as PurplePdfDocument } from './General/PurplePdfDocument.svg';
export { default as Download2 } from './General/Download2.svg';
export { default as PurplePlus } from './General/PurplePlus.svg';
export { default as PurpleMinus } from './General/PurpleMinus.svg';
export { default as PurpleArrowDown } from './General/PurpleArrowDown.svg';
export { default as NoResultsImage2 } from './General/NoResults2.svg';
export { default as NoDataFoundImage2 } from './NoDataFound2.svg';
export { default as BluePaycheckIcon } from './BluePaycheckIcon.svg';
export { default as BlueFormIcon } from './BlueFormIcon.svg';
export { default as AccordionArrowPurple } from './General/AccordionArrowPurple.svg';
export { default as PurpleCircleBG } from './General/PurpleCircleBG.svg';
export { default as PurpleArrowUp } from './General/PurpleArrowUp.svg';
export { default as PurpleArrowDown2 } from './General/PurpleArrowDown2.svg';
export { default as PurpleAlert } from './General/PurpleAlert.svg';
export { default as PurpleTriangle } from './General/PurpleTriangle.svg';
export { default as PurpleAdvancedSearchIcon } from './Payments&Deductions/PurpleAdvancedSearchIcon.svg';
export { default as CircularArrows } from './Payments&Deductions/CircularArrows.svg';
export { default as PlusInsideCircle } from './Payments&Deductions/PlusInsideCircle.svg';
export { default as MinusInsideCircle } from './Payments&Deductions/MinusInsideCircle.svg';
export { default as WhiteX } from './General/WhiteX.svg';
export { default as PurpleDateIcon } from './General/PurpleDateIcon.svg';
export { default as VideoCircle } from './Treatment/VideoCircle.svg';
export { default as FloatingVector } from './Treatment/FloatingVector.svg';
export { default as Checkmark } from './Payments&Deductions/Checkmark.svg';
export { default as CheckmarkError } from './Payments&Deductions/CheckmarkError.svg';
export { default as CheckmarkChecked } from './Payments&Deductions/CheckmarkChecked.svg';
export { default as RequestRefund } from './Payments&Deductions/RequestRefund.svg';
export { default as PermitsAndCertificates } from './UniversalRequest/PermitsAndCertificates.svg';
export { default as BackButtonArrow } from './UniversalRequest/BackButtonArrow.svg';
export { default as PurpleWarning } from './PurpleWarning.svg';
export { default as PurpleSearchIcon } from './UniversalRequest/PurpleSearchIcon.svg';
export { default as SquarePurpleCloseButton } from './UniversalRequest/SquarePurpleCloseButton.svg';
export { default as CheckMark } from './UniversalRequest/CheckMark.svg';
export { default as CirclePurpleCloseButton } from './UniversalRequest/CirclePurpleCloseButton.svg';
export { default as ErrorWarningSign } from './General/ErrorWarningSign.svg';
export { default as OtpLoginLeftArrow } from './OtpLogin/LeftArrow.svg';
export { default as OtpLoginRightArrow } from './OtpLogin/RightArrow.svg';
export { default as OtpLoginCloseButton } from './OtpLogin/CloseButton.svg';
export { default as SuccessGreenVi } from './SuccessGreenVi.svg';
export { default as Logo2 } from './Header/Logo.svg';
export { default as SearchNormal } from './Header/SearchNormal.svg';
export { default as LinearUser } from './Header/LinearUser.svg';
export { default as FooterVectors } from './Footer/FooterVectors.svg';
export { default as Call } from './Footer/Call.svg';
export { default as Message } from './Footer/Message.svg';
export { default as MOD } from './Footer/MOD.svg';
export { default as FooterCall } from './Footer/FooterCall.svg';
export { default as FooterContact } from './Footer/FooterContact.svg';
export { default as FooterBackgroundVectors } from './Footer/FooterBackgroundVectors.svg';
export { default as MobileContact } from './Header/MobileContact.svg';
export { default as MobileUser } from './Header/MobileUser.svg';
export { default as MobileMenu } from './Header/MobileMenu.svg';
export { default as NewRequestButton } from './MedicalReferrals/NewRequestButton.svg';
export { default as TitleBackgroundVectors } from './MedicalReferrals/TitleBackgroundVectors.svg';
export { default as ArrowRightWhite } from './General/ArrowRightWhite.svg';
export { default as NoImageAvatar } from './SideBurger/NoImageAvatar.svg';
export { default as SideBurgerBell } from './SideBurger/SideBurgerBell.svg';
export { default as SideBurgerPersonalDetails } from './SideBurger/SideBurgerPersonalDetails.svg';
export { default as SideBurgerHome } from './SideBurger/SideBurgerHome.svg';
export { default as SideBurgerGeneral } from './SideBurger/SideBurgerGeneral.svg';
export { default as SideBurgerMedical } from './SideBurger/SideBurgerMedical.svg';
export { default as SideBurgerRights } from './SideBurger/SideBurgerRights.svg';
export { default as SideBurgerRecognition } from './SideBurger/SideBurgerRecognition.svg';
export { default as SideBurgerRequests } from './SideBurger/SideBurgerRequests.svg';
export { default as SideBurgerDocuments } from './SideBurger/SideBurgerDocuments.svg';
export { default as MedicalReferralsFilters } from './MedicalReferrals/MedicalReferralsFilters.svg';
export { default as SelfReferralIcon } from './MedicalReferrals/SelfReferralIcon.svg';
export { default as FilledArrowUp } from './General/FilledArrowUp.svg';
export { default as AccordionArrowWhite2 } from './General/AccordionArrowWhite2.svg';
export { default as AppointmentLogo } from './PersonalTeam/AppointmentLogo.svg';
export { default as CallCenterLogo } from './PersonalTeam/CallCenterLogo.svg';
export { default as ComplaintsCenterLogo } from './PersonalTeam/ComplaintsCenterLogo.svg';
export { default as PersonalTeamLogo } from './PersonalTeam/PersonalTeamLogo.svg';
export { default as PurpleFax } from './PersonalTeam/PurpleFax.svg';
export { default as PurplePhone } from './PersonalTeam/PurplePhone.svg';
export { default as SupportCenterLogo } from './PersonalTeam/SupportCenterLogo.svg';
export { default as PurpleLocation } from './General/PurpleLocation.svg';
export { default as PurpleExternalLink } from './General/PurpleExternalLink.svg';
export { default as DisabledVeteranBg } from './DisabledVeteran/DisabledVeteranBg.svg';
export { default as DisabledVeteranNoAccess } from './DisabledVeteran/DisabledVeteranNoAccess.svg';
export { default as DisabledVeteranBgMobile } from './DisabledVeteran/DisabledVeteranBgMobile.svg';
export { default as ViewPersonalDetails } from './Header/ViewPersonalDetails.svg';
export { default as UpdatePersonalDetails } from './Header/UpdatePersonalDetails.svg';
export { default as ViewDisabledVeteranCard } from './Header/ViewDisabledVeteranCard.svg';
export { default as SignOut } from './Header/SignOut.svg';
export { default as LinearUserOpen } from './Header/LinearUserOpen.svg';
export { default as ExternalLink } from './General/ExternalLink.svg';
export { default as Trash } from './General/Trash.svg';
export { default as PurpleClose } from './General/PurpleClose.svg';
export { default as CircleBlueCloseButton } from './General/CircleBlueCloseButton.svg';
export { default as DeleteVector } from './General/DeleteVector.svg';
export { default as SuccessRequest } from './UniversalRequest/SuccessRequest.svg';
export { default as UniversalRequestSubject1 } from './UniversalRequest/icon-1.svg';
export { default as UniversalRequestSubject2 } from './UniversalRequest/icon-2.svg';
export { default as UniversalRequestSubject3 } from './UniversalRequest/icon-3.svg';
export { default as UniversalRequestSubject4 } from './UniversalRequest/icon-4.svg';
export { default as UniversalRequestSubject5 } from './UniversalRequest/icon-5.svg';
export { default as UniversalRequestSubject6 } from './UniversalRequest/icon-6.svg';
export { default as UniversalRequestSubject7 } from './UniversalRequest/icon-7.svg';
export { default as UniversalRequestSubject8 } from './UniversalRequest/icon-8.svg';
export { default as UniversalRequestSubject9 } from './UniversalRequest/icon-9.svg';
export { default as UniversalRequestSubject10 } from './UniversalRequest/icon-10.svg';
export { default as UniversalRequestSubject11 } from './UniversalRequest/icon-11.svg';
export { default as UniversalRequestSubject12 } from './UniversalRequest/icon-12.svg';
export { default as UniversalRequestSubject13 } from './UniversalRequest/icon-13.svg';
export { default as UniversalRequestSubject14 } from './UniversalRequest/icon-14.svg';
export { default as UniversalRequestSubject15 } from './UniversalRequest/HeartWithPurpleHeartInside.svg';
export { default as UniversalRequestSubject16 } from './UniversalRequest/PaperWithCalc.svg';
export { default as UniversalRequestTab1 } from './UniversalRequest/Tab1.svg';
export { default as UniversalRequestTab2 } from './UniversalRequest/Tab2.svg';
export { default as PurpleSortIcon } from './Documents/PurpleSortIcon.svg';
export { default as ContentHeaderBG } from './ContentHeader/ContentHeaderBG.svg';
export { default as HotAirBalloon } from './UniversalRequest/HotAirBalloon.svg';
export { default as ArrowRight } from './General/ArrowRight.svg';
export { default as FromHeart } from './CompassRights/FromHeart.svg';
export { default as EmploymentIcon } from './CompassRights/EmploymentIcon.svg';
export { default as SocialHelp } from './CompassRights/SocialHelp.svg';
export { default as Statoscope } from './CompassRights/Statoscope.svg';
export { default as CompassRightsMobileBackground } from './CompassRights/CompassRightsMobileBackground.svg';
export { default as RightsTypes } from './CompassRights/RightsTypes.svg';
export { default as RegularCalendar } from './General/RegularCalendar.svg';
export { default as UploadFilesIcon } from './UniversalRequest/UploadFilesIcon.svg';
export { default as UploadFilesPurpleIcon } from './UniversalRequest/UploadFilesPurple.svg';
export { default as TrashCanDark } from './General/TrashCan.svg';
export { default as WatchFileDark } from './General/WatchFile.svg';
export { default as UniversalRequestPurpleExclamationMark } from './UniversalRequest/PurpleExclamationMark.svg';
export { default as UniversalRequestFullPurpleExclamationMark } from './UniversalRequest/FullPurpleExclamationMark.svg';
export { default as HeaderIcons } from './Header/HeaderIcons.svg';
export { default as AccordionArrowPurpleClose } from './General/AccordionArrowPurpleClose.svg';
export { default as OutlinedBluePhone } from './General/OutlinedBluePhone.svg';
export { default as AppliesCloseButton } from './Applies/AppliesCloseButton.svg';
export { default as OutlinedPhone } from './Applies/OutlinedPhone.svg';
export { default as OutlinedScreen } from './Applies/OutlinedScreen.svg';
export { default as OutlinedPerson } from './Applies/OutlinedPerson.svg';
export { default as OutlinedPersonColorful } from './Applies/OutlinedPersonColorful.svg';
export { default as ErrorScreen } from './General/ErrorScreen.svg';
export { default as MaleIcon } from './PersonalDetails/MaleIcon.svg';
export { default as FemaleIcon } from './PersonalDetails/FemaleIcon.svg';
export { default as LegalRepresentBadge } from './PersonalDetails/LegalRepresentBadge.svg';
export { default as PurpleOutlinedAlert } from './General/PurpleOutlinedAlert.svg';
export { default as RequestsStepperCompleted } from './Requests/RequestsStepperCompleted.svg';
export { default as ContactUsHeadphones } from './Requests/ContactUsHeadphones.svg';
export { default as RequestsStepperActive } from './Requests/RequestsStepperActive.svg';
export { default as GreenCheckmark } from './General/GreenCheckmark.svg';
export { default as SmallGreenCheckmark } from './General/SmallGreenCheckmark.svg';
export { default as MinusButton } from './ExpenseClaim/MinusButton.svg';
export { default as Duplicate } from './ExpenseClaim/Duplicate.svg';
export { default as PlusButton } from './ExpenseClaim/PlusButton.svg';
export { default as MobilePlusButton } from './ExpenseClaim/MobilePlusButton.svg';
export { default as ExpenseClaimLeftArrow } from './ExpenseClaim/LeftArrow.svg';
export { default as NewIcon } from './General/NewIcon.svg';
export { default as NewLabelIcon } from './General/NewLabelIcon.svg';
export { default as NewLabelBig } from './General/NewLabelBig.svg';
export { default as ServerErrorIcon_1 } from './General/ServerErrorIcon_1.svg';
export { default as ServerErrorIcon_2 } from './General/ServerErrorIcon_2.svg';
export { default as ServerErrorIcon_3 } from './General/ServerErrorIcon_3.svg';
export { default as PurpleDownloadIcon } from './General/PurpleDownloadIcon.svg';
export { default as RenewPrescription } from './Home/RenewPrescription.svg';
export { default as OrderMedications } from './Home/OrderMedications.svg';
export { default as OrderEquipments } from './Home/OrderEquipments.svg';
export { default as UploadPrescription } from './Home/UploadPrescription.svg';
export { default as RequestPrescription } from './Home/RequestPrescription.svg';
export { default as CloseModal } from './General/CloseModal.svg';
export { default as DeleteVectorNoTic } from './General/DeleteVectorNoTic.svg';
export { default as SmallDelete } from './General/SmallDelete.svg';
export { default as ArrowRightBlue } from './General/ArrowRightBlue.svg';
export { default as ArrowLeftBlue } from './General/ArrowLeftBlue.svg';
export { default as ArrowRightBlueBold } from './General/ArrowRightBlueBold.svg';
export { default as Add } from './General/Add.svg';
export { default as Copy } from './General/Copy.svg';
export { default as Expand } from './General/Expand.svg';
export { default as Collapse } from './General/Collapse.svg';
export { default as SubmitApplication } from './Home/SubmitApplication.svg';
export { default as CompassRights } from './Home/CompassRights.svg';
export { default as DigitalCertificate } from './Home/DigitalCertificate.svg';
export { default as OrderTreatments } from './Home/OrderTreatments.svg';
export { default as BigButton } from './Home/BigButton.svg';
export { default as ActionsListButtonFull } from './Home/ActionsListButtonFull.svg';
export { default as YourTeam } from './Footer/YourTeam.svg';
export { default as Cake } from './Header/Cake.svg';
export { default as NextPrevBtn } from './General/NextPrevBtn.svg';
export { default as NextPrevBtnDisabled } from './General/NextPrevBtnDisabled.svg';
export { default as Download2White } from './General/Download2White.svg';
export { default as LeftArrowWhite } from './General/LeftArrowWhite.svg';
export { default as MobileViewPersonalDetails } from './MobileMenu/MobileViewPersonalDetails.svg';
export { default as MobileViewUpdates } from './MobileMenu/MobileViewUpdates.svg';
export { default as Home } from './MobileMenu/Home.svg';
export { default as Economic } from './MobileMenu/Economic.svg';
export { default as Medical } from './MobileMenu/Medical.svg';
export { default as Rights } from './MobileMenu/Rights.svg';
export { default as Recognition } from './MobileMenu/Recognition.svg';
export { default as Applies } from './MobileMenu/Applies.svg';
export { default as Documents } from './MobileMenu/Documents.svg';
export { default as PurpleArrowLeft } from './General/PurpleArrowLeft.svg';
export { default as ToInfo } from './MobileMenu/ToInfo.svg';
export { default as Disconnect } from './MobileMenu/Disconnect.svg';
export { default as PurpleBack } from './General/PurpleBack.svg';
export { default as PaychecksNoData } from './PaychecksNoData.svg';
export { default as toggleX } from './General/toggleX.svg';
export { default as toggleV } from './General/toggleV.svg';
export { default as BlackCake } from './Home/BlackCake.svg';
export { default as VIconCircle } from './General/VIconCircle.svg';
export { default as WriteIcon } from './General/WriteIcon.svg';
export { default as CheckedIcon } from './General/CheckedIcon.svg';
export { default as UncheckedIcon } from './General/UncheckedIcon.svg';
export { default as BGNewMobile } from './BGNewMobile.svg';
export { default as BlueDelete } from './General/BlueDelete.svg';
export { default as equipmentIcon1 } from './Equipment/equipmentIcon1.svg';
export { default as AppartmentRent } from './Home/AppartmentRent.svg';
export { default as Studies } from './Home/Studies.svg';
export { default as Nursing } from './Home/Nursing.svg';
export { default as RecommendOrderTreatments } from './Home/RecommendOrderTreatments.svg';
export { default as RecommendMedicine } from './Home/RecommendMedicine.svg';
export { default as RecommendExpiredMedicine } from './Home/recommendExpiredMedicine.svg';
export { default as equipmentIcon2 } from './Equipment/equipmentIcon2.svg';
export { default as equipmentIcon3 } from './Equipment/equipmentIcon3.svg';
export { default as equipmentIcon4 } from './Home/equipmentIcon4.svg';
export { default as UploadDraggingFile } from './General/UploadDraggingFile.svg';
export { default as PurpleOutlineWarningIcon } from './General/PurpleOutlineWarningIcon.svg';
export { default as PreOrderIcon } from './Equipment/PreOrderIcon.svg';
export { default as MinusPurple } from './General/MinusPurple.svg';
export { default as PlusPurple } from './General/PlusPurple.svg';
export { default as PurpleChecked } from './General/PurpleChecked.svg';
export { default as PurpleUnchecked } from './General/PurpleUnchecked.svg';
export { default as PenIcon } from './Pen.svg';
export { default as SuccessIcon } from './Equipment/Success.svg';
export { default as StepIcon1 } from './Equipment/Steps/StepIcon1.svg';
export { default as StepIcon2 } from './Equipment/Steps/StepIcon2.svg';
export { default as StepIcon3 } from './Equipment/Steps/StepIcon3.svg';
export { default as StepIcon4 } from './Equipment/Steps/StepIcon4.svg';
export { default as PurpleCheckedBullet } from './Equipment/PurpleCheckedBullet.svg';
export { default as CreateMedicineIcon } from './General/CreateMedicineIcon.svg';
export { default as PurpleSearch } from './General/PurpleSearch.svg';
export { default as UploadFileBlue } from './General/UploadFileBlue.svg';
export { default as PurpleVi } from './General/PurpleVi.svg';
export { default as RedWarning } from './General/RedWarning.svg';
export { default as MagnifyGlassPaperCheckmarks } from './RecognitionStatus/MagniflyPaperCheckmarksIntro.svg';
export { default as CallCenterLogoNoBG } from './CallCenterLogoNoBorder.svg';
export { default as ChipStepperLocation } from './ChipStepperLocation.svg';
export { default as PurpleCheckMark } from './PurpleCheckmark.svg';
export { default as WhiteArrowRight } from './WhiteArrowRight.svg';
export { default as MiniBurger } from './MobileMenu/MiniBurger.svg';
export { default as MiniBurgerDesk } from './SideBurger/MiniBurger.svg';
export { default as ToInfoDesk } from './SideBurger/ToInfo.svg';
export { default as DisconnectDesk } from './SideBurger/Disconnect.svg';
export { default as Examination } from './Status/Examination.svg';
export { default as DoctorOpinion } from './Status/DoctorOpinion.svg';
export { default as WaitingForDecision } from './Status/WaitingForDecision.svg';
export { default as MedicalCommitte } from './Status/MedicialCommitte.svg';
export { default as RejectionStatus } from './Status/Rejection.svg';
export { default as ReqPaused } from './Status/ReqPaused.svg';
export { default as ReqApprovedStamp } from './Status/ReqApprovedStamp.svg';
export { default as ReqApproved } from './Status/ReqApproved.svg';
export { default as B2CBackground } from './B2C/background.svg';
export { default as B2CLogo } from './B2C/logo.svg';
export { default as B2CLoginLogo } from './B2C/loginLogo.svg';
export { default as B2CLoginError } from './B2C/loginError.svg';
export { default as B2CPhone } from './B2C/phone.svg';
export { default as B2CMobileLogo } from './B2C/MobileLogo.svg';
export { default as B2CMobileBackground } from './B2C/MobileBackground.svg';
export { default as AppointmentOrder } from './AppointmentOrder.svg';
export { default as BGDesktop } from './BGDesktop.svg';
export { default as RefreshIcon } from './refresh.svg';
export { default as UnreadNotifications } from './SideBurger/UnreadNotifications.svg';
export { default as UnreadNotificationsMobile } from './MobileMenu/UnreadNotifications.svg';
export { default as SuppliersBGDesk } from './Suppliers/BGDesk.svg';
export { default as SuppliersBGMobile } from './Suppliers/BGMobile.svg';
export { default as TherapySearch } from './Suppliers/TherapySearch.svg';
export { default as DoctorsSearch } from './Suppliers/DoctorsSearch.svg';
export { default as PurpleEditPen } from './Suppliers/PurpleEdit.svg';
export { default as B2CShikumLogo } from './B2C/ShikumLogo.svg';
export { default as B2CIntro } from './B2C/Intro.svg';
export { default as B2CCallHeadphone } from './B2C/CallHeadphone.svg';
export { default as PurpleSmsIcon } from './PurpleSms.svg';
export { default as BlueRequest } from './Suppliers/BlueRequest.svg';
export { default as ShareMediaPurple } from './Suppliers/ShareMedia.svg';
export { default as PurpleIcon } from './Suppliers/Copy.svg';
export { default as WhatsAppIcon } from './Suppliers/WhatsApp.svg';
export { default as MessengerAppIcon } from './Suppliers/MessengerApp.svg';
export { default as PurpleFillShareMedia } from './Suppliers/PurpleFillShareMedia.svg';
export { default as BlueFilters } from './Suppliers/Filters.svg';
export { default as PurpleFilterSliders } from './Suppliers/PurpleFilterSliders.svg';
export { default as BlueFilterSliders } from './Suppliers/BlueFilterSliders.svg';
export { default as PurpleEmail } from './Suppliers/PurpleEmail.svg';
export { default as GreenCheckMark } from './Suppliers/GreenCheckmark.svg';
export { default as OutlinedWhitePhone } from './Suppliers/OutlinedWhitePhone.svg';
export { default as RadioIcon } from './Suppliers/Radio.svg';
export { default as RadioChecked } from './Suppliers/RadioChecked.svg';
export { default as LoaderGIF } from './loading.gif';
export { default as PaginationDisabledBtn } from './Suppliers/DisabledBtn.svg';
export { default as PaginationActiveBtn } from './Suppliers/ActiveBtn.svg';
export { default as UpdatePassword } from './Header/UpdatePassword.svg';
export { default as AddInputs } from './Suppliers/Add.svg';
export { default as RemoveInputs } from './Suppliers/Remove.svg';
export { default as NotificationBing } from './NotificationBing.svg';
export { default as Notes } from './Notes.svg';
export { default as BenefitsIcon } from './BenefitsIcon.svg';
export { default as RecognitionStatusIcon } from './RecognitionStatusIcon.svg';
export { default as ExitDoor } from './ExitDoor.svg';
export { default as ExitDoorWhite } from './ExitDoorWhite.svg';
export { default as GreenTriangle } from './GreenTriangle.svg';
export { default as LightBlueX } from './General/LightBlueX.svg';
export { default as CannabisIcon } from './Reimbursements/Cannabis.svg';
export { default as SmallCheckmark } from './General/SmallCheckmark.svg';
export { default as View } from './General/View.svg';
export { default as InvoiceIcon } from './Reimbursements/Invoice.svg';
export { default as InvoiceDocumentIcon } from './Reimbursements/InvoiceDocumentIcon.svg';
export { default as GreenInvoiceIcon } from './Reimbursements/GreenInvoice.svg';
export { default as OcrLoadingAnimation } from './Reimbursements/OcrLoadingAnimation.gif';
export { default as PurpleInfo } from './General/PurpleInfo.svg';
export { default as TrashBin } from './General/TrashBin.svg';
export { default as WhiteTrashBin } from './General/WhiteTrashBin.svg';
export { default as DownloadIconMobile } from './Reimbursements/DownloadIconMobile.svg';
export { default as ReimbursementsBgImg } from './Reimbursements/BgImg.svg';
export { default as PurpleUploadIcon } from './PurpleUploadIcon.svg';
export { default as NewBlueDelete } from './General/NewBlueDelete.svg';
export { default as LightUncheckedIcon } from './General/LightUncheckedIcon.svg';
export { default as UploadWhite } from './General/UploadWhite.svg';
export { default as GrayX } from './General/GrayX.svg';
export { default as AccordionArrowDisabled } from './AccordionArrowDisabled.svg';
export { default as AlternativeIcon } from './Reimbursements/AlternativeIcon.svg';
export { default as AlternativeBG } from './Reimbursements/AlternativeBG.svg';
export { default as BlackX } from './Home/BlackX.svg';
export { default as Cart } from './Home/Cart.svg';
export { default as SquareArrowCorner } from './Home/SquareWithArrowCorner.svg';
export { default as WarningRedTriangle } from './General/WarningRedTriangle.svg';
export { default as BluePrinter } from './General/BluePrinter.svg';
export { default as HeartIcon } from './Reimbursements/HeartIcon.svg';
export { default as ExampleCertificate } from './Reimbursements/ExampleCertificate.svg';
export { default as OpenTrashBin } from './Home/TrashBin.svg';
export { default as PlusInsideSquare } from './Home/PlusInsideSquare.svg';
export { default as CopyIcon } from './Home/CopyIcon.svg';
export { default as FamilyMembersIntro } from './Reimbursements/FamilyMembersIntro.svg';
export { default as PersonWithBoxes } from './Documents/PersonWithBoxes.svg';
export { default as BlueEye } from './Documents/BlueEye.svg';
export { default as CircleThreeDotsPopover } from './Documents/CircleThreeDotsPopover.svg';
export { default as PurpleEye } from './Documents/PurpleEye.svg';
export { default as DocReceived } from './Documents/DocReceived.svg';
export { default as PaperPlane } from './Documents/PaperPlane.svg';
export { default as RevertedArrowsBlue } from './Documents/RevertedArrowsBlue.svg';
export { default as RevertedArrowsWhite } from './Documents/RevertedArrowsWhite.svg';
export { default as ArrowBackWhite } from './Documents/ArrowBackWhite.svg';
export { default as LoadingThreeDotsGIF } from './Documents/loading.gif';
export { default as NoFilteredResults } from './Documents/NoFilteredResults.svg';
export { default as PurpleCircledPlus } from './Documents/PurpleCircledPlus.svg';
export { default as PurpleCircledMinus } from './Documents/PurpleCircledMinus.svg';
export { default as Settings } from './Documents/Settings.svg';
export { default as TrashCanBlackSmall } from './TrashCanBlackSmall.svg';
export { default as CopyInvoice } from './CopyInvoice.svg';
export { default as SuccessIconGreen } from './SuccessIcon.svg';
export { default as GreenNiceBg } from './GreenNiceBg.svg';
export { default as TargetImage } from './TargetImage.svg';
export { default as GoodHandsIcon } from './GoodHands.svg';
export { default as PTSDIcon } from './PTSD.svg';
export { default as NewContactIcon } from './NewContactIcon.svg';
export { default as RecordIcon } from './RecordIcon.svg';
export { default as PurpleOutlineOppoAlert } from './PurpleOutlineOppoAlert.svg';
export { default as SortArrows } from './General/SortArrows.svg';
export { default as CheckedWhiteIcon } from './CheckedWhiteIcon.svg';
export { default as VBlueApprove } from './VBlueApprove.svg';
export { default as DocumentGreenText } from './Documents/DocumentGreenText.svg';
export { default as OrangeWarningOutline } from './OrangeWarningOutline.svg';
export { default as DeleteContact } from './DeleteContact.svg';
export { default as LeftOpenArrow } from './LeftOpenArrow.svg';
export { default as SortPurple } from './SortPurple.svg';
export { default as ExcelIcon } from './General/Excel.svg';
export { default as Record } from './Record.svg';
export { default as RecordActive } from './RecordActive.svg';
export { default as PurpleArrow } from './PurpleArrow.svg';
export { default as Like } from './Like.svg';
export { default as Dislike } from './Dislike.svg';
export { default as PartialLike } from './PartialLike.svg';
export { default as MarkAsNew } from './General/MarkAsNew.svg';
export { default as ChatSquareLike } from './ChatSquareLike.svg';
export { default as Feedback } from './General/Feedback.svg';
export { default as FeedbackDone } from './General/FeedbackDone.svg';
export { default as MobileFeedback } from './General/MobileFeedback.svg';
export { default as MobileFeedbackDone } from './General/MobileFeedbackDone.svg';
export { default as VeryHelpful } from './General/VeryHelpful.svg';
export { default as PartiallyHelpful } from './General/PartiallyHelpful.svg';
export { default as NotHelpful } from './General/NotHelpful.svg';
export { default as SortBlue } from './General/SortBlue.svg';
export { default as OnlineAppointmentIcon } from './OnlineAppointment.svg';
export { default as PlayCircle } from './PlayCircle.svg';
export { default as PauseCircle } from './PauseCircle.svg';
export { default as PlayCircleFilled } from './PlayCircleFilled.svg';
export { default as PauseCircleFilled } from './PauseCircleFilled.svg';
export { default as BluePhone } from './BluePhone.svg';
export { default as BlackPhone } from './BlackPhone.svg';
export { default as Waiting } from './AdminFeedback/Waiting.svg';
export { default as Handled } from './AdminFeedback/Handled.svg';
export { default as InProcess } from './AdminFeedback/InProcess.svg';
export { default as UploadIconBlue } from './General/UploadIconBlue.svg';
export { default as ParamedicalSearch } from './Suppliers/ParamedicalSearch.svg';
export { default as MedicalEquipmentSearch } from './Suppliers/MedicalEquipmentSearch.svg';
export { default as MedicalEquipmentRefundSuccess } from './Refunds/MedicalEquipmentRefundSuccess.svg';
export { default as RequestDeliveredAnimation } from './Refunds/RequestDelivered.svg';
export { default as MedicalEquipmentScanLine } from './Refunds/MedicalEquipmentScanLine.svg';
export { default as MedicalEquipmentScanStars } from './Refunds/MedicalEquipmentScanStars.svg';
export { default as MedicalEquipmentAttachInvoice } from './Refunds/MedicalEquipmentAttachInvoice.svg';
export { default as AttachInvoiceAiAnimation } from './Refunds/AttachInvoiceAI.svg';
export { default as MedicalEquipmentInvalidFile } from './Refunds/MedicalEquipmentInvalidFile.svg';
export { default as MedicalEquipmentStepperInactive } from './Refunds/MedicalEquipmentStepperInactive.svg';
export { default as MedicalEquipmentStepperActive } from './Refunds/MedicalEquipmentStepperActive.svg';
export { default as MedicalEquipmentStepperCompleted } from './Refunds/MedicalEquipmentStepperCompleted.svg';
export { default as MedicalEquipmentStepperInactiveDesktop } from './Refunds/MedicalEquipmentStepperInactiveDesktop.svg';
export { default as MedicalEquipmentStepperActiveDesktop } from './Refunds/MedicalEquipmentStepperActiveDesktop.svg';
export { default as MedicalEquipmentStepperCompletedDesktop } from './Refunds/MedicalEquipmentStepperCompletedDesktop.svg';
export { default as AlertInfoBannerAnimation } from './Refunds/AlertInfoBannerAnimation.svg';
export { default as ClockInfoBannerAnimation } from './Refunds/ClockInfoBannerAnimation.svg';
export { default as MedicalServiceSearch } from './Suppliers/MedicalServiceSearch.svg';
export { default as ImagingInstituteSearch } from './Suppliers/ImagingInstituteSearch.svg';
export { default as ImagingInstituteSearchTitle } from './Suppliers/ImagingInstituteSearchTitle.svg';
export { default as MedicalReferralsIcon } from './MedicalReferralsIcon.svg';
export { default as AppliesIcon } from './AppliesIcon.svg';
export { default as LongTermIcon } from './LongTermIcon.svg';
export { default as PaymentsAndDeductionsIcon } from './PaymentsAndDeductionIcon.svg';
export { default as SearchEmpty } from './SearchEmpty.svg';
export { default as SearchNotFound } from './SearchNotFound.svg';
export { default as YourTeamSearchResult } from './SearchResults/YourTeam.svg';
export { default as CompassSearchResult } from './SearchResults/Compass.svg';
export { default as DocumentsSearchResult } from './SearchResults/Documents.svg';
export { default as PayslipsSearchResult } from './SearchResults/Payslips.svg';
export { default as PurpleCircledLeft } from './General/PurpleCircledLeft.svg';
export { default as GrayCircledLeft } from './General/GrayCircledLeft.svg';
export { default as PurpleCircledRight } from './General/PurpleCircledRight.svg';
export { default as GrayCircledRight } from './General/GrayCircledRight.svg';
export { default as InfoTip } from './General/InfoTip.svg';
export { default as ExternalLinkLeft } from './General/ExternalLinkLeft.svg';
export { default as CollapseOpenPurple } from './General/CollapseOpenPurple.svg';
export { default as Welfare } from './General/Welfare.svg';
export { default as CheckmarkV } from './General/CheckmarkV.svg';
export { default as CheckmarkBlue } from './General/CheckmarkBlue.svg';
export { default as BlueDateIcon } from './General/BlueDateIcon.svg';
export { default as InfoTipNew } from './General/InfoTipNew.svg';
export { default as Present } from './MedicalCar/Present.svg';
export { default as RingBell } from './MedicalCar/RingBell.svg';
export { default as PurpleV } from './MedicalCar/PurpleV.svg';
export { default as MedicalCommitteesIconMobile } from './MedicalCommitteesIconMobile.png';
export { default as BlueLocationIcon } from './BlueLocationIcon.svg';
export { default as DiscussionDatePostponed } from './DiscussionDatePostponed.svg';
export { default as DiscussionNotHeld } from './DiscussionNotHeld.svg';
export { default as TreatmentSearchResult } from './SearchResults/Treatments.svg';
export { default as ClaimsSearchResult } from './SearchResults/Claims.svg';
export { default as MedicationsSearchResult } from './SearchResults/Medications.svg';
export { default as EquipmentSearchResult } from './SearchResults/Equipment.svg';
export { default as AvatarWarning } from './AvatarWarning.svg';
export { default as ExtraHearing } from './ExtraHearing.svg';
export { default as NotEligibleIcon } from './MedicalCar/NotEligibleIcon.svg';
export { default as Calculator } from './DisabilityCalculator/Calculator.svg';
export { default as DisabilityCalculatorSearchIcon } from './DisabilityCalculator/SearchIcon.svg';
export { default as DisabilityCalculatorSearchIconBG } from './DisabilityCalculator/SearchIconBG.svg';
export { default as DisabilityCalculatorBackArrow } from './DisabilityCalculator/BackArrowIcon.svg';
export { default as DisabilityCalculatorBackArrowBG } from './DisabilityCalculator/BackArrowBG.svg';
export { default as HartMsg } from './DisabilityCalculator/HartMsg.svg';
export { default as ArrowWithBackground } from './General/ArrowWithBackground.svg';
export { default as ArrowDownWithBG } from './General/ArrowDownWithBG.svg';
export { default as HeartNew } from './HeartNew.svg';
export { default as NewLogo } from './Header/NewLogo.svg';
export { default as NewLogoMobile } from './Header/NewLogoMobile.svg';
export { default as MobileFooterLogo } from './Header/MobileFooterLogo.svg';
export { default as LogoB2CMobile } from './B2C/LogoB2CMobile.svg';
export { default as LogoB2C } from './B2C/LogoB2C.svg';
export { default as DisabilityCalculatorContinueButtonIcon } from './DisabilityCalculator/ContinueButtonIcon.svg';
export { default as DisabilityCalculatorAlertIcon } from './DisabilityCalculator/AlertIcon.svg';
export { default as DisabilityCalculatorV } from './DisabilityCalculator/V.svg';
export { default as DisabilityCalculatorX } from './DisabilityCalculator/X.svg';
export { default as MaintenanceIcon } from './Maintenance.svg';
export { default as SearchIcon } from './Header/SearchIcon.svg';
export { default as PayAttention } from './DisabilityCalculator/PayAttention.svg';
export { default as ArrowDownPurple } from './DisabilityCalculator/ArrowDownPurple.svg';
export { default as EditIcon } from './DisabilityCalculator/Edit.svg';
export { default as ArrowUpPurple } from './DisabilityCalculator/ArrowUpPurple.svg';
export { default as DisabilityCalculatorEmailIcon } from './DisabilityCalculator/EmailIcon.svg';
export { default as DisabilityCalculatorWhatsappIcon } from './DisabilityCalculator/WhatsappIcon.svg';
export { default as DestinationFlag } from './DisabilityCalculator/DestinationFlag.svg';
export { default as DestinationFlagFinal } from './DisabilityCalculator/DestinationFlagFinal.svg';
export { default as CounterGraphIcon } from './CounterGraphIcon.svg';
export { default as RecognizedAsDisabledIcon } from './RecognizedAsDisabled.svg';
export { default as FirstTimeRecognitionIcon } from './FirstTimeRecognition.svg';
export { default as MaleAvatar } from './MaleAvatar.svg';
export { default as FemaleAvatar } from './FemaleAvatar.svg';
export { default as ChurnRateBackground } from './ChurnRateBackground.svg';
export { default as TotalFormsCardBackground } from './RecognitionDashboard/TotalFormsCardBackground.svg';
export { default as GreenArrowUp } from './RecognitionDashboard/GreenArrowUp.svg';
export { default as RedArrowDown } from './RecognitionDashboard/RedArrowDown.svg';
export { default as NoResultsIcon } from './DisabilityCalculator/NoResults.svg';
export { default as CalculatorIcon } from './DisabilityCalculator/CalculatorIcon.svg';
export { default as CheckedBlueRadio } from './DisabilityCalculator/CheckedBlueRadio.svg';
export { default as UncheckedBlueRadio } from './DisabilityCalculator/UncheckedBlueRadio.svg';
export { default as GoLeft } from './General/GoLeft.svg';
export { default as DisabilityCalculatorEditIcon } from './DisabilityCalculator/EditIcon.svg';
export { default as DisabilityCalculatorDeleteIcon } from './DisabilityCalculator/DeleteIcon.svg';
export { default as ApplyToWing } from './UniversalRequest/ApplyToWing.svg';
export { default as NewLeftArrow } from './UniversalRequest/NewLeftArrow.svg';
export { default as PurpleBulb } from './DisabilityCalculator/PurpleBulb.svg';
export { default as XClicked } from './DisabilityCalculator/XClicked.svg';
export { default as VClicked } from './DisabilityCalculator/VClicked.svg';
export { default as LightBulbIcon } from './LightBulbIcon.svg';
export { default as CircleBlueWhiteV } from './DisabilityCalculator/CircleBlueWhiteV.svg';
export { default as WhiteV } from './DisabilityCalculator/WhiteV.svg';
export { default as ArrowBack } from './ArrowBack.svg';
export { default as UploadFile } from './General/UploadFile.svg';
export { default as GrayTrash } from './General/GrayTrash.svg';
export { default as PurpleArrowIcon } from './General/PurpleArrow.svg';
// export { default as PurpleArrowIcon } from './General/PurpleArrow.svg';
export { default as SelfServiceReferralsCategoryHospitals } from './SelfServiceReferrals/CategoryHospitals.svg';
export { default as SelfServiceReferralsCategoryMental } from './SelfServiceReferrals/CategoryMental.svg';
export { default as SelfServiceReferralsCategoryParamedical } from './SelfServiceReferrals/CategoryParamedical.svg';
export { default as SelfServiceReferralsCategoryDoctors } from './SelfServiceReferrals/CategoryDoctors.svg';
export { default as SelfServiceReferralsCategoryImaging } from './SelfServiceReferrals/CategoryImaging.svg';
export { default as SelfServiceReferralsCategoryLabTests } from './SelfServiceReferrals/CategoryLabTests.svg';
export { default as SelfServiceReferralsCarouselArrowLeft } from './SelfServiceReferrals/CarouselArrowLeft.svg';
export { default as SelfServiceReferralsCarouselArrowLeftDisabled } from './SelfServiceReferrals/CarouselArrowLeftDisabled.svg';
export { default as SelfServiceReferralsDoctorsFieldResultIcon } from './SelfServiceReferrals/DoctorsFieldResultIcon.svg';
export { default as SelfServiceReferralsParamedicalFieldResultIcon } from './SelfServiceReferrals/ParamedicalFieldResultIcon.svg';
export { default as SelfServiceReferralsHospitalsFieldResultIcon } from './SelfServiceReferrals/HospitalsFieldResultIcon.svg';
export { default as SelfServiceReferralsImagingFieldResultIcon } from './SelfServiceReferrals/ImagingFieldResultIcon.svg';
export { default as SelfServiceReferralsEquipmentItemIcon } from './SelfServiceReferrals/EquipmentItemIcon.svg';
export { default as SelfServiceReferralsConsumableEquipmentIcon } from './SelfServiceReferrals/ConsumableEquipmentIcon.svg';
export { default as SelfServiceReferralsCommunicationInfoIcon } from './SelfServiceReferrals/CommunicationInfoIcon.svg';
export { default as SelfServiceReferralsFooterSearchSuppliersIcon } from './SelfServiceReferrals/FooterSearchSuppliersIcon.svg';
export { default as SelfServiceReferralsFooterContactDepartmentIcon } from './SelfServiceReferrals/FooterContactDepartmentIcon.svg';
export { default as SelfServiceReferralsToastSuccessIcon } from './SelfServiceReferrals/ToastSuccessIcon.svg';
export { default as SelfServiceReferralsToastFailedIcon } from './SelfServiceReferrals/ToastFailedIcon.svg';
export { default as SelfServiceReferralsToastRetryIcon } from './SelfServiceReferrals/ToastRetryIcon.svg';
export { default as SelfServiceReferralsToastCloseIcon } from './SelfServiceReferrals/ToastCloseIcon.svg';
export { default as SelfServiceReferralsMonthlyLimitIllustration } from './SelfServiceReferrals/MonthlyLimitIllustration.svg';
export { default as SelfServiceReferralsEditDateIcon } from './SelfServiceReferrals/EditDateIcon.svg';
export { default as SelfServiceReferralsMentalConfirmPersonIcon } from './SelfServiceReferrals/MentalConfirmPersonIcon.svg';
export { default as SelfServiceReferralsRegionFilterArrowDown } from './SelfServiceReferrals/RegionFilterArrowDown.svg';
export { default as UploadedFile } from './UniversalRequest/UploadedFile.svg';
export { default as Watch } from './General/Watch.svg';
export { default as UploadedSuccessfully } from './UniversalRequest/UploadedSuccessfully.svg';
export { default as NewRightArrow } from './General/NewRightArrow.svg';
export { default as ZoomIn } from './General/ZoomIn.svg';
export { default as ZoomOut } from './General/ZoomOut.svg';
export { default as Refresh } from './General/Refresh.svg';
export { default as SortArrowUp } from './General/SortArrowUp.svg';
export { default as SortArrowDown } from './General/SortArrowDown.svg';
export { default as BluePhoneIcon } from './General/BluePhone.svg';
export { default as ArrowDownBtn } from './DisabilityCalculator/ArrowDown.svg';
export { default as ArrowUpBtn } from './DisabilityCalculator/ArrowUp.svg';
export { default as DoctorExplain } from './DisabilityCalculator/DoctorExplain.svg';
export { default as GlobalPurple } from './Suppliers/Global.svg';
export { default as LawyersInfo } from './Suppliers/LawyersInfo.svg';
export { default as SelfServiceReferralsModalIcon } from './SelfServiceReferrals/ModalIcon.svg';
export { default as SelfServiceReferralsTypeSelectionIcon } from './SelfServiceReferrals/TypeSelectionIcon.svg';
export { default as SelfServiceReferralsTherapistIcon } from './SelfServiceReferrals/TherapistIcon.svg';
export { default as SelfServiceReferralsActionArrowLeft } from './SelfServiceReferrals/ActionArrowLeft.svg';
export { default as SelfServiceReferralsFamilyMemberPersonIcon } from './SelfServiceReferrals/FamilyMemberPersonIcon.svg';
export { default as SelfServiceReferralsFamilyTreatmentHeaderIcon } from './SelfServiceReferrals/FamilyTreatmentHeaderIcon.svg';
export { default as SelfServiceReferralsIndividualTreatmentIcon } from './SelfServiceReferrals/IndividualTreatmentIcon.svg';
export { default as SelfServiceReferralsCoupleTreatmentIcon } from './SelfServiceReferrals/CoupleTreatmentIcon.svg';
export { default as SelfServiceReferralsCorrectionMessageIcon } from './SelfServiceReferrals/CorrectionMessageIcon.svg';
export { default as SelfServiceReferralsProduceCommitmentIcon } from './SelfServiceReferrals/ProduceCommitmentIcon.svg';
export { default as SelfServiceReferralsCommitmentDateHeaderIcon } from './SelfServiceReferrals/CommitmentDateHeaderIcon.svg';
export { default as MapView } from './Suppliers/MapView.svg';
export { default as DocIcon } from './Suppliers/doc.svg';
